// Generated by `npm run grazing` (scripts/grazing.ts) from no archive: the reef fish's tables, stepped a year. Do
// not edit by hand: change the script and run it. tests/grazing.test.ts builds it again and fails if this file is not
// what the tables give.

/**
 * Each Maui Nui island's herbivorous fish (the bullethead, the palenose, the redlip, the kala, the nenue and the manini), kg a km² of its hard
 * bottom (`ISLAND_HARD_BOTTOM_M2`), across the fish tables' year at their expected values, in `REEF_ISLANDS` order:
 * the biomass each stratum's grazing is anchored at (M167, `grazing.ts`). MEASURED by the script.
 */
export const HERBIVORES_KG_KM2: readonly number[] = [3036.74, 2555.23, 3453.06, 3971.78];
